import {CommonError} from '$commons/errors/commonErrors'

/**
 * @description 404 에러 발생
 */
export class NotFoundError extends CommonError {
    name = 'NotFoundError'

    constructor(
        msg: string,
        public code: number = 404,
    ) {
        super(msg)
    }
}

/**
 * @description 부적절한 id로 접근해 자산 정보가 존재하지 않음
 */
export class AssetNotExistError extends NotFoundError {
    static code = 'AssetNotExist'

    constructor() {
        super('asset not exist')
    }

    name = 'AssetNotExistError'
}

/**
 * @description 해지된 id로 자산 상세 페이지에 접근해 목록페이지로 이동 필요
 */
export class AssetNotListableError extends CommonError {
    redirectUrl: string

    constructor(redirectUrl: string) {
        super('Asset not listable')
        this.redirectUrl = redirectUrl
    }

    name = 'AssetNotListableError'
}
